// Footer-Uhr: Uhrzeit in Hamburg als Skala (Figma footer-clock, Doku „Footer clock“).
if (!customElements.get('footer-clock')) {
  customElements.define(
    'footer-clock',
    class FooterClock extends HTMLElement {
      constructor() {
        super();
        this.time = this.querySelector('.footer-clock__time');
        this.formatter = new Intl.DateTimeFormat('de-DE', {
          timeZone: 'Europe/Berlin',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        });
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
      }

      connectedCallback() {
        this.update();
        this.syncSeconds();
        this.scheduleNextMinute();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      onVisibilityChange() {
        if (document.visibilityState !== 'visible') return;
        this.update();
        this.syncSeconds();
      }

      scheduleNextMinute() {
        const now = new Date();
        const delay = 60000 - (now.getSeconds() * 1000 + now.getMilliseconds());
        this.timeout = setTimeout(() => {
          this.update();
          this.scheduleNextMinute();
        }, delay);
      }

      update() {
        const parts = this.formatter.formatToParts(new Date());
        const hours = parts.find((part) => part.type === 'hour').value;
        const minutes = parts.find((part) => part.type === 'minute').value;
        const position = ((Number(hours) % 12) + Number(minutes) / 60) / 12;

        this.time.textContent = `${hours}:${minutes}`;
        this.time.setAttribute('datetime', `${hours}:${minutes}`);
        this.style.setProperty('--clock-position', position);
        this.classList.toggle('footer-clock--label-left', position > 0.5);
      }

      // Mobile Sekundenskala: die CSS-Animation läuft über 5 Sekunden (ein langer Strich je Zyklus),
      // die negative Verzögerung setzt sie auf die aktuelle Sekunde.
      syncSeconds() {
        const now = new Date();
        const phase = (now.getSeconds() % 5) + now.getMilliseconds() / 1000;
        this.style.setProperty('--clock-phase', `-${phase}s`);
        this.classList.remove('footer-clock--running');
        void this.offsetWidth;
        this.classList.add('footer-clock--running');
      }
    }
  );
}

// Menüs mobil als Akkordeon; ab 990 px sind die Listen immer sichtbar.
if (!customElements.get('footer-accordion')) {
  customElements.define(
    'footer-accordion',
    class FooterAccordion extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.footer-block__toggle');
        this.toggle?.addEventListener('click', () => {
          const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
          this.toggle.setAttribute('aria-expanded', String(!expanded));
        });
      }
    }
  );
}
